// Common module
import './src/common/index.js';

// Forum module
import './src/forum/index.js';

// Default export for compatibility
export default {};